import store from '@/vuex';

export const hasPrivilege = (privilege) => {
  const userAuthorities = store.getters['auth/getUserRole'];
  const authoritiesArray = Array.isArray(userAuthorities) ? userAuthorities : userAuthorities.split(',');

  return authoritiesArray.some((authority) => authority === privilege);
};
